(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    (function() {
    // Check if page reloaded after successful submission
    if (window.location.search.includes('customer_posted=true')) {
      var forms = document.querySelectorAll('.email-signup__form');
      forms.forEach(function(form) {
        var inputGroup = form.querySelector('.email-signup__input-group');
        if (inputGroup) inputGroup.style.display = 'none';
        var success = document.createElement('div');
        success.className = 'email-signup__message';
        success.style.marginTop = '8px';
        success.innerHTML = '<p class="email-signup__message-text">Thanks for signing up! Check your inbox for your welcome discount.</p>';
        form.appendChild(success);
      });
      // Clean up the URL
      window.history.replaceState({}, '', window.location.pathname);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
